import { INPUT_BASE_PADDING_Y_PX, InputAdornment, TextField } from '@chronosphereio/chrono-ui';
import { useDebouncedState } from '@chronosphereio/shared';
import { Magnify as SearchIcon } from 'mdi-material-ui';
import { ContentWithLegendQuickFilterProps } from './model/content-with-legend-model';

export function ContentWithLegendQuickFilter({
  show,
  placeholder = 'Search series',
  onChange,
}: ContentWithLegendQuickFilterProps) {
  const [filter, setFilter] = useDebouncedState<string>(
    '',
    (newValue) => {
      onChange?.(newValue);
    },
    200
  );

  if (!show) {
    return null;
  }

  return (
    <TextField
      fullWidth
      value={filter}
      onChange={(e) => {
        setFilter(e.target.value);
      }}
      placeholder={placeholder}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon color="inherit" fontSize="small" />
          </InputAdornment>
        ),
        sx: {
          paddingLeft: 1,

          // Needed for the search box for the quick filter and the buttons for the
          // toggle mode to have a consistent height in the toolbar.
          // TODO: this should be cleaned up after fixing sc-129147
          [`&.MuiInputBase-adornedStart`]: {
            paddingTop: `${INPUT_BASE_PADDING_Y_PX.medium}px !important`,
            paddingBottom: `${INPUT_BASE_PADDING_Y_PX.medium}px !important`,
          },
        },
      }}
    />
  );
}
